import { ITable, TypeColumn, TypeFormat } from '@/interface/general/ITable';
import { effect, inject, Injectable, signal, WritableSignal } from '@angular/core';
import { IModificarPdf } from '../interface/modificar.interface';
import { PdfService } from './pdf.service';

@Injectable({
  providedIn: 'root',
})
export class TableService {
  //Servicios
  private pdfService = inject(PdfService); 

  // Parametros
  table = signal<ITable>({} as ITable);
  data = signal<IModificarPdf[]>([] as IModificarPdf[]);
  dataSelected = signal<IModificarPdf[]>([] as IModificarPdf[]);

  constructor() {
    this.setTable();
  }

  setTable() {
    const table: ITable = {
      fieldId: 'Id',
      paginator: false,
      isDataLocal: true,
      columns: [
        {
          field: 'Id',
          label: '',
          type: TypeColumn.MULTI_SELECT,
        },
        {
          field: 'Id',
          label: 'Id',
          type: TypeColumn.NUMBER,
        },
        {
          field: 'NombreArchivo',
          label: 'Nombre',
          type: TypeColumn.TRUNCATE_TEXT,
        },
        {
          field: 'NoPagina',
          label: 'No Pagina',
          type: TypeColumn.NUMBER,
        },
        {
          field: 'OrdenOriginal',
          label: 'Orden Original',
          type: TypeColumn.NUMBER,
        },
        {
          field: 'ContentLength',
          label: 'Tamaño (Kb)',
          type: TypeColumn.NUMBER,
        },
        {
          field: 'FechaRegistro',
          label: 'Fecha Registro',
          type: TypeColumn.DATE,
          format: TypeFormat.DATE
        },
        {
          field: 'Id',
          label: 'Acciones',
          type: TypeColumn.ACTIONS,
          actions:  [
            {
              field: 'Id',
              label: '-',
              type: TypeColumn.ACTION,
              icon: 'pi-file-pdf',
              action: (rowData) => this.onGetPage(rowData),
            },
            {
              field: 'Id',
              label: '-',
              type: TypeColumn.ACTION,
              icon: 'pi-arrow-circle-up',
              action: (rowData) => this.onMoveUp(rowData),
            },
            {
              field: 'Id',
              label: '-',
              type: TypeColumn.ACTION,
              icon: 'pi-arrow-circle-down',
              action: (rowData) => this.onMoveDown(rowData),
            },
          ],
        },
      ],
    };
    this.table.set(table);
  }

  reset(){
    this.data.set([]);
    this.dataSelected.set([]);
  }

  load(event: any) {
  }

  async selected(event: IModificarPdf[]) {
    this.dataSelected.set(event);

    // Actuliza cambios
    await this.updateAllRows();
  }

  onMoveUp(file: IModificarPdf) {
    this.updatePosition(file, true);
  }

  onMoveDown(file: IModificarPdf) {
    this.updatePosition(file, false);
  }

  async updatePosition(currentfile: IModificarPdf, isUp: boolean) { 
    // Actualiza posicion
    this.data.update(currentItems => {
      const index = this.data().findIndex((f) => f.Id === currentfile.Id);
      const newItems = [...currentItems]; 
      const pos = isUp ? index - 1 : index + 1;
      const item = newItems.splice(index, 1)[0];
      newItems.splice(pos, 0, item);
      return newItems; 
    });

    // Actuliza cambios
    await this.updateAllRows();
  } 
  
  async updateAllRows() {
    // Actualiza numeracion y estado
    this.data().forEach((file, index) => { 
      file.NoPagina = index + 1
      file.Estado2 = this.dataSelected().some((item) => item.Id === file.Id)
    });

    // Envia solo los campos necesarios
    const pages = this.data().map((item) => ({ Id: item.Id, Estado2: item.Estado2, NoPagina: item.NoPagina }));

    // Actualiza cambios en el registro
    await this.updateModify(pages);
  }

  async updateModify(pages: IModificarPdf[]) {
    return await this.pdfService.updateModify(pages)
  }

  async onGetPage(currentfile: IModificarPdf) {
    return await this.pdfService.getPage(currentfile.Id ?? 0);
  }
}
